// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorBoundary_wrapper__kMewT","header":"errorBoundary_header__SoKQ1","body":"errorBoundary_body__rzFfH"};